import requestModule from '@/application/libs/requestModule'
import eventModule from '@/application/libs/eventModule'
import Util from '@/application/libs/util'
import moment from 'moment'
import { t } from 'i18next'
export default {
    
    /**
     * Get unit data and set it on modal
     * form
     * 
     * @param {Array<Object>} fieldOptions
     */
    getUnitData(fieldOptions, params){
        requestModule.postRequest('getData', {
            FROM: "FILIAL",
            PARAMS: params
        }).then(response=>{
            if(response.dataset && response.dataset.data){
                fieldOptions.options = response.dataset.data;
            }
        });
    },

    /**
     * Get service data and set it on modal
     * form
     * 
     * @param {Array<Object>} fieldOptions
     */
    getServiceData(fieldOptions, params){
        Util.ifFilterSelected(function (){
            return requestModule.postRequest('getData', {
                FROM: "SERVICOS",
                PARAMS: params            
            })}).then(response=>{
            if(response.dataset && response.dataset.data){
                fieldOptions.options = response.dataset.data;
            }
        });
    },

    saveIfIsValid(context){
        if(this.validateFilledFields(context)){

            let boData = Util.getFilterInSession();
            let oldBoData = {...boData};
            Object.assign(boData, context.header.data.unit);
            Object.assign(boData, context.header.data.service);
            Object.assign(boData, context.header.data.contract);

            boData.DTMESCARD = moment(context.header.data.cardDate, 'YYYY-MM').startOf('month').format('DD/MM/YYYY');
            Util.setLocalVar('backOfficeData', boData);
            sessionStorage.setItem('filterData', JSON.stringify(boData));
            eventModule.$emit('updateBoData', {oldValue: oldBoData, newValue: boData});
            Util.showSuccessNotification({
                title: t('saved_data'),
                text: t('parameterized_data')
            });
        } else {
            Util.showErrorNotification({
                title: t('error_applying'),
                text: t('fill_in_all_fields')
            });
        }
    },

    validateFilledFields(context){
        let data = context.header.data;
        let fields = context.header.fields;

        fields.find(f=>f.name=='unit').invalid = !data.unit;
        fields.find(f=>f.name=='service').invalid = !data.service;
        fields.find(f=>f.name=='contract').invalid = !data.contract;
        fields.find(f=>f.name=='cardDate').invalid = !data.cardDate;
        
        return data.unit && data.cardDate &&
            data.service && data.contract;
    }
}